import { $Window } from 'app/services';

const CLASS_NAME = 'show-spinner';

export class SpinnerService {

    public static hide() {
        $Window.body.classList.remove(CLASS_NAME);
    }

    public static show() {
        $Window.body.classList.add(CLASS_NAME);
    }

    public static toggle() {
        if ($Window.body.classList.contains(CLASS_NAME)) {
            SpinnerService.hide();
        } else {
            SpinnerService.show();
        }
    }

}
